// Farrowing's list and record share one resource and one mounted surface.
// Admit exactly one decoded-safe record id; malformed descendants must recover
// rather than rendering a record under an unrelated or truncated URL.
export const PIG_FARROWING_INDEX_PATHNAME = '/pig/farrowing';
export const PIG_FARROWING_RECORD_PATHNAME_PREFIX = '/pig/farrowing/';

function safeSegment(value: string): boolean {
  return value.trim() !== '' && value !== '.' && value !== '..' && !/[\\/\0\r\n?#]/.test(value);
}

export function isCanonicalPigFarrowingPathname(pathname: unknown): pathname is string {
  if (typeof pathname !== 'string') return false;
  if (pathname === PIG_FARROWING_INDEX_PATHNAME) return true;
  if (!pathname.startsWith(PIG_FARROWING_RECORD_PATHNAME_PREFIX)) return false;
  const raw = pathname.slice(PIG_FARROWING_RECORD_PATHNAME_PREFIX.length);
  if (!safeSegment(raw)) return false;
  try {
    return safeSegment(decodeURIComponent(raw));
  } catch {
    return false;
  }
}

export function isCanonicalPigFarrowingLocation(location: unknown): boolean {
  if (typeof location === 'string') return isCanonicalPigFarrowingPathname(location);
  if (!location || typeof location !== 'object' || Array.isArray(location)) return false;
  return isCanonicalPigFarrowingPathname((location as {pathname?: unknown}).pathname);
}
